import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import React from 'react';

export interface TableAction {
  isHidden?: boolean;
  title: string;
  onClick: () => void;
  showTopSeparator?: boolean;
}

interface TableActionsProps {
  inlineActions?: TableAction[];
  dropdownActions?: TableAction[];
}

export const TableActions: React.FC<TableActionsProps> = ({
  inlineActions,
  dropdownActions,
}) => {
  return (
    <div className="flex flex-row items-center space-x-1 justify-end action">
      {inlineActions?.map((action, index) => (
        <div
          key={index}
          onClick={action.onClick}
          className="hover:bg-primary-500 rounded-md cursor-pointer"
        >
          <span className="w-full text-start px-3">{action.title}</span>
        </div>
      ))}
      <div className="relative">
        <Menu as="div" className="inline-block text-left">
          <MenuButton className="block text-primary-500 hover:text-primary-200 p-1">
            <span className="sr-only">Open options</span>
            <ChevronDownIcon width="20" height="20" />
          </MenuButton>

          <MenuItems
            anchor="bottom end"
            className="z-50 mt-1 w-40 rounded-md bg-white p-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
          >
            {dropdownActions
              ?.filter((action) => !action.isHidden)
              .map((action, index) => (
                <React.Fragment key={index}>
                  {action.showTopSeparator && (
                    <div className="border-t border-gray-200 my-1.5" />
                  )}

                  <MenuItem>
                    {({ focus }) => (
                      <div
                        onClick={action.onClick}
                        className={`rounded-md cursor-pointer px-3 py-0.5 md:text-sm text-xs w-full text-start ${
                          focus ? 'bg-primary-500 text-white' : 'text-gray-700'
                        }`}
                      >
                        {action.title}
                      </div>
                    )}
                  </MenuItem>
                </React.Fragment>
              ))}
          </MenuItems>
        </Menu>
      </div>
    </div>
  );
};
